export const fieldNames = {
  BLOCK_CATEGORY: 'blockCategory',
  USER_INPUT: 'userInput',
};
